// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{height:100%;padding:20px}.inbox-wrapper{display:grid;grid-gap:5px;grid-template-columns:repeat(3, 1fr);grid-template-rows:auto;padding-bottom:50px}", ""]);
// Exports
module.exports = exports;
